import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import detector from "i18next-browser-languagedetector";
import authFa from './auth/fa.js'
import authEn from './auth/en.js'
import dashboardFa from './dashboard/fa.js'
import dashboardEn from './dashboard/en.js'
import chatFa from './chat/fa.js'
import chatEn from './chat/en.js'
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  fa: {
    translation: {
      auth: {
        ...authFa
      },
      dashboard: {
        ...dashboardFa
      },
      chat: {
        ...chatFa
      }
    }
  },
  en: {
    translation: {
      auth: {
        ...authEn
      },
      dashboard: {
        ...dashboardEn
      },
      chat: {
        ...chatEn
      }
    }
  }
}

i18n
 // .use(detector)
 .use(initReactI18next) // passes i18n down to react-i18next
 .init({
   resources,
   lng: 'fa', // use en if detected lng is not available

   interpolation: {
     escapeValue: false // react already safes from xss
   }
 })

export default i18n
